import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import EmployeeCompactList from "../components/EmployeeCompactList";

// Parent route element for the Employee Master split-view pilot - see
// MasterDetailLayout.jsx for the reusable shell and AppRoutes.jsx for how
// the index/new/edit/promote children now nest under this instead of being
// flat, full-page routes.
const EmployeeSplitView = () => <MasterDetailLayout list={<EmployeeCompactList />} />;

export default EmployeeSplitView;
